/**
 * Service for setting the debug status of the app.
 */
class DebugService {
  constructor() {
    'ngInject';

    this.enabled = false;
  }
}

const mod = angular.module('app.debug.service', [])

.service('DebugService', DebugService);

export default mod.name;
